<nav class="navbar navbar-expand-sm navbar-dark bg-primary  navbar-expand-lg">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img src="../assets/au.png" alt="" class="d-inline-block align-text-top" />
      {{ title }}
    </a>

    <ul class="navbar-nav text-left" style="width: 100%;">
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link" routerLink="/">Home</a>
      </li>
      @for (userLink of userLinks(); track userLink.name) {
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="{{userLink.link}}">{{userLink.name}}</a>
        </li>
      }
    </ul>

    <div class="text-white d-flex align-items-right">
      @if (signedIn()) {
        <div class="nav-item dropdown" dropdown>
        <button
          class="btn btn-primary dropdown-toggle"
          dropdownToggle
          type="button"
          aria-expanded="false"
        >
          <i class="bi bi-person"></i> {{ getLoginInfo() }}
        </button>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-end">
          <li>
            <button
              class="dropdown-item d-flex align-items-center"
              (click)="handleLogin()"
            >
              <b>Logout</b>
            </button>
          </li>
        </ul>
      </div>
      } @else {
        <button class="btn btn-primary btn-lg" (click)="handleLogin()">Login</button>
      }
  </div>

  </div>
</nav>